import { Discovery } from '../progress-accordions/Discovery';
import { Introduction } from '../progress-accordions/Introduction';
import { Planning } from '../progress-accordions/Planning';
import { Action } from '../progress-accordions/Action';
import { Reflect } from '../progress-accordions/Reflect';
import {
  HubStatusEnum,
  ProgressStepStatusEnum,
  ProjectHubResponse,
  SimplifiedUserRole,
} from '@platform/client/schemas';
import { HubProgressHeader } from '../shared-components/HubProgressHeader';
import { useEffect, useState } from 'react';

export const IndividualProgressAccordions = ({ hubData }: { hubData: ProjectHubResponse }) => {
  const [openAccordion, setOpenAccordion] = useState<string>();
  const {
    progress,
    userType,
    project,
    status,
    introduction,
    planningGuideUrl,
    surveyUrl,
    storyUrl,
  } = hubData;
  const matchFailed = progress?.discovery === ProgressStepStatusEnum.failure;
  const completedSteps = Object.values(progress).filter(
    (status) =>
      status === ProgressStepStatusEnum.success ||
      status === ProgressStepStatusEnum.inactive_in_progress,
  ).length;
  const totalSteps = Object.keys(progress).length;

  const userCurrentStep = Object.entries(progress).find(
    ([, status]) =>
      status === ProgressStepStatusEnum.active_in_progress ||
      status === ProgressStepStatusEnum.inactive_in_progress,
  )?.[0];
  useEffect(() => {
    if (userCurrentStep) {
      setOpenAccordion(userCurrentStep);
    }
  }, [userCurrentStep]);

  const onAccordionToggle = (accordionKey: string) => (isOpen: boolean) => {
    if (isOpen) {
      setOpenAccordion(accordionKey);
    }
  };

  return (
    <>
      {!matchFailed && (
        <HubProgressHeader
          completed={completedSteps}
          total={totalSteps}
          project={project}
          includeDates={progress.discovery === ProgressStepStatusEnum.success}
          allowDateEdit={
            userType === SimplifiedUserRole.PROFESSIONAL && status === HubStatusEnum.Matched
          }
          isTeam={false}
        />
      )}
      <Introduction
        status={ProgressStepStatusEnum.success}
        isTeam={false}
        userType={userType}
        introduction={introduction}
        isOpen={openAccordion === 'introduction'}
        onToggle={onAccordionToggle('introduction')}
      />
      <Discovery
        status={progress.discovery}
        isTeam={false}
        userType={userType}
        discovery={hubData.discovery}
        discoveryModalData={{
          introductionId: introduction.id,
          assignmentDiscoveryId: hubData.discovery.id,
          otherPartyName:
            userType === SimplifiedUserRole.PROFESSIONAL ?
              hubData.organization.name
            : `${hubData.professional.firstname} ${hubData.professional.lastname}`,
          userType: userType,
          projectId: project?.id,
          projectName: project?.name,
        }}
        isOpen={openAccordion === 'discovery'}
        onToggle={onAccordionToggle('discovery')}
      />
      <Planning
        status={progress.planning}
        isTeam={false}
        userType={userType}
        projectId={project?.id}
        planningGuideUrl={planningGuideUrl}
        isOpen={openAccordion === 'planning'}
        onToggle={onAccordionToggle('planning')}
      />
      <Action
        status={progress.action}
        isTeam={false}
        userType={userType}
        projectId={hubData.project?.id}
        planningGuideUrl={planningGuideUrl}
        isOpen={openAccordion === 'action'}
        onToggle={onAccordionToggle('action')}
        hubActionData={hubData.action}
      />
      <Reflect
        status={progress.reflect}
        isTeam={false}
        userType={userType}
        surveyUrl={surveyUrl}
        storyUrl={storyUrl}
        isOpen={openAccordion === 'reflect'}
        onToggle={onAccordionToggle('reflect')}
      />
    </>
  );
};
